import React, { FC } from 'react';
import { useCourseMutation } from '../../api/course-admin';

import * as CSS from './course-styles';
import { Course, UpdateStatus } from '../../../database.schema';

type UpdateButtonProps = {
  course: Course;
  courseIndex: number;
  setUpdateStatus: (updateStatus: UpdateStatus) => void;
  setShowUpdate: (value: boolean) => void;
  isDisabled: boolean;
};

export const UpdateButton: FC<UpdateButtonProps> = ({ course, courseIndex, setUpdateStatus, setShowUpdate, isDisabled }) => {
  const mutation = useCourseMutation();
  const saveCourse = () => {
    if (course) {
      const dataToSave = { course: { ...course }, courseIndex };
      if (dataToSave) {
        mutation.mutate(
          { ...dataToSave },
          {
            onSuccess: (data) => {
              setShowUpdate(false);
            },
            onError: (error) => {
              setUpdateStatus({ success: false, error: true });
              console.log('<><><>ERROR<><><><', error);
            },
          },
        );
      }
    }
  };
  return (
    <CSS.Button data-testid="submit-course" onClick={() => saveCourse()} disabled={isDisabled}>
      Save
    </CSS.Button>
  );
};
